'use client';

import { Hit as AlgoliaHit } from 'instantsearch.js/es/types';
import { ProductItem } from './ProductItem';
import { IProductItem } from './interfaces';
import { ProductHit } from '@workspace/interfaces';

interface ProductItemHitProps {
  hit: AlgoliaHit<ProductHit>;
  ctaText?: string;
}

export function ProductItemHit({ hit, ctaText }: ProductItemHitProps) {
  const product: IProductItem = {
    _id: hit.objectID,
    name: hit.title || '',
    description: hit.description || '',
    image: {
      asset: {
        url: hit.thumbnailImage || '',
      },
    },
    viewDetailLink: {
      type: 'internal',
      url: hit.url || '',
    },
  };

  return <ProductItem key={product._id} product={product} text={ctaText} />;
}
